// Enable after Telegram sign-in and the AI-manager flow are ready for release.
export const AI_MANAGERS_AVAILABLE = false;
